'use client';

export { CampaignCovers as PromotionBanners } from './campaign-covers';

export function RollDogBanner({ onTry }: { onTry: () => void }) {
  return (
    <button
      className="roll-dog-campaign"
      onClick={onTry}
      aria-label="Твой новый краш. Попробовать ролл-дог с крабом"
    >
      <span className="roll-dog-artwork">
        <img
          src="/storefront/campaign-v6-roll-dog-sidebar.webp"
          width={1000}
          height={1500}
          alt=""
          loading="lazy"
          decoding="async"
        />
        <span className="roll-dog-copy">
          <small>Ролл-дог с крабом</small>
          <strong>
            Твой новый
            <br />
            краш.
          </strong>
        </span>
      </span>
      <span className="roll-dog-cta">Хочу попробовать</span>
    </button>
  );
}
